/**
 * Eagle Bourbon — Popular Categories
 * File: assets/eagle-popular-categories.js
 *
 * Handles:
 *  - Carousel mode: Swiper init with responsive breakpoints
 *  - Grid mode: no Swiper needed, pure CSS grid
 *  - Reads layout mode from data-layout attribute on section
 *  - Shopify Theme Editor live reload support
 */

(function () {
  'use strict';

  var swiperInstances = [];

  /* ── Destroy any existing swiper instances for a section ── */
  function destroySwiper(section) {
    swiperInstances = swiperInstances.filter(function (entry) {
      if (entry.sectionEl === section) {
        try { entry.swiper.destroy(true, true); } catch (e) {}
        return false;
      }
      return true;
    });
  }

  /* ── Init Swiper for a single carousel section ── */
  function initCarousel(section) {
    var swiperEl = section.querySelector('.eagle-categories__swiper');
    if (!swiperEl) return;

    var prevBtn      = swiperEl.querySelector('.eagle-categories__btn--prev');
    var nextBtn      = swiperEl.querySelector('.eagle-categories__btn--next');
    var paginationEl = swiperEl.querySelector('.eagle-categories__pagination');
    var totalSlides  = swiperEl.querySelectorAll('.eagle-categories__slide').length;
    var sectionId    = section.id || '';

    var swiper = new Swiper(swiperEl, {

      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 12,

      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous category',
        nextSlideMessage: 'Next category',
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      grabCursor: true,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      threshold: 5,

      loop: totalSlides > 4,
      loopAdditionalSlides: 2,
      speed: 420,

      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
      },

      pagination: {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
      },

      breakpoints: {
        0: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2.4,
          slidesPerGroup: 1,
          spaceBetween: 12,
        },
        600: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 14,
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        900: {
          slidesPerView: 5,
          slidesPerGroup: 2,
          spaceBetween: 16,
        },
        1100: {
          slidesPerView: totalSlides <= 6 ? totalSlides : 6,
          slidesPerGroup: totalSlides <= 6 ? totalSlides : 6,
          spaceBetween: 18,
          loop: false,
          allowTouchMove: totalSlides > 6,
        },
      },

      on: {
        init: function (sw) {
          updateNavVisibility(sw);
        },
        breakpoint: function (sw) {
          updateNavVisibility(sw);
        },
        slideChange: function (sw) {
          var activeSlide = sw.slides[sw.activeIndex];
          if (!activeSlide) return;
          var label = activeSlide.querySelector('.eagle-categories__label');
          if (!label) return;
          var liveEl = document.getElementById('eagle-cats-sr-live-' + sectionId);
          if (!liveEl) {
            liveEl = document.createElement('span');
            liveEl.id = 'eagle-cats-sr-live-' + sectionId;
            liveEl.setAttribute('aria-live', 'polite');
            liveEl.setAttribute('aria-atomic', 'true');
            liveEl.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
            document.body.appendChild(liveEl);
          }
          liveEl.textContent = label.textContent.trim();
        },
      },
    });

    function updateNavVisibility(sw) {
      if (!prevBtn || !nextBtn) return;
      var showNav = sw.params.loop || (sw.slides.length > sw.params.slidesPerView);
      prevBtn.style.display = showNav ? '' : 'none';
      nextBtn.style.display = showNav ? '' : 'none';
    }

    swiperInstances.push({ sectionEl: section, swiper: swiper });
  }

  /* ── Init a single section based on its layout mode ── */
  function initSection(section) {
    destroySwiper(section);
    var layout = section.dataset.layout || 'carousel';
    if (layout === 'carousel') {
      if (typeof Swiper !== 'undefined') {
        initCarousel(section);
      } else {
        pollSwiper(section);
      }
    }
    /* Grid mode: nothing to do — CSS handles it */
  }

  /* ── Poll until Swiper loads ── */
  function pollSwiper(section) {
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (typeof Swiper !== 'undefined') {
        clearInterval(poll);
        initCarousel(section);
      }
      if (attempts > 40) clearInterval(poll);
    }, 100);
  }

  /* ── Init all sections on the page ── */
  function initAll() {
    document.querySelectorAll('.eagle-categories[data-layout]').forEach(initSection);
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ── Shopify Theme Editor support ── */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.eagle-categories');
      if (section) initSection(section);
    });
    document.addEventListener('shopify:block:select', initAll);
    document.addEventListener('shopify:block:deselect', initAll);
  }

})();